import { restClient } from '../config/restClient'

const endpoint = hiringTeamId => `/api/company/v2/hiring_teams/${hiringTeamId}/member_profiles`

export const getHiringTeamMemberProfiles = async (hiringTeamId, params) => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'GET',
    params,
  })
  return response.data
}
